class Permissions {
  static validate = (permission) => {
    try {
      const userPermissions = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).permissoes : []
      if (!Array.isArray(userPermissions)) return false
      // if (userPermissions[0] === 'administracao:visualizar') return true

      if (typeof permission === 'string') {
        if (userPermissions.includes(permission)) return true
      } else if (Array.isArray(permission)) {
        let permited = false

        permission.forEach(perm => {
          if (userPermissions.includes(perm)) permited = true
        })

        if (permited) return true
      } else if (typeof permission === 'object') {
        if (permission.actions.length === 0) return false

        let permited = false

        permission.actions.forEach(perm => {
          if (userPermissions.includes(perm.action) && perm.route === permission.routeName) permited = true
        })

        if (permited) return true
      }

      return false
    } catch (error) {
      console.error('Formato de permissão não reconhecido', error)
      return false
    }
  }

  static admin = () => {
    try {
      const user = JSON.parse(localStorage.getItem('user'))

      if (user.fk_int_id_integrador == null && user.fk_dis_id_distribuidor == null && user.fk_rev_id_revendedor == null) {
        return true
      } else {
        return false
      }
    } catch (error) {
      console.error('Formato de permissão não reconhecido', error)
    }
  }

  static distributor = () => {
    try {
      const user = JSON.parse(localStorage.getItem('user'))

      if (user.fk_dis_id_distribuidor !== null) {
        return user.fk_dis_id_distribuidor
      } else {
        return false
      }
    } catch (error) {
      console.error('Formato de permissão não reconhecido', error)
    }
  }

  static integrator = () => {
    try {
      const user = JSON.parse(localStorage.getItem('user'))

      if (user.fk_int_id_integrador !== null) {
        return user.fk_int_id_integrador
      } else {
        return false
      }
    } catch (error) {
      console.error('Formato de permissão não reconhecido', error)
    }
  }

  static revendor = () => {
    try {
      const user = JSON.parse(localStorage.getItem('user'))

      if (user.fk_rev_id_revendedor !== null) {
        return user.fk_rev_id_revendedor
      } else {
        return false
      }
    } catch (error) {
      console.error('Formato de permissão não reconhecido', error)
    }
  }

  static groupAdmin = () => {
    try {
      const userGroup = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).fk_gru_id_grupo : []
      if (userGroup === 1) {
        return true
      } else {
        return false
      }
    } catch (error) {
      console.error('Formato de permissão não reconhecido', error)
    }
  }
}

export default Permissions



// WEBPACK FOOTER //
// ./src/helper/permissions.js